module.exports = "<main class=\"well well--2x error-container\">\n  <div class=\"typ typ--hdg1\">Error</div>\n  <div class=\"vr vr--2x\"></div>\n  <div class=\"typ typ--breathable ut-error-message\">\n    {{$ctrl.error.message}}\n    <span ng-if=\"$ctrl.error.link\">\n      <a ng-href=\"{{$ctrl.error.link}}\" ng-bind=\"$ctrl.error.linkText\"></a>.\n    </span>\n  </div>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/error/error.html
// module id = 409
// module chunks = 0